__turbopack_context__.v({
  "fade-in": "Breadcrumb-module-scss-module__fDxavq__fade-in",
  "item": "Breadcrumb-module-scss-module__fDxavq__item",
  "label": "Breadcrumb-module-scss-module__fDxavq__label",
  "link": "Breadcrumb-module-scss-module__fDxavq__link",
  "list": "Breadcrumb-module-scss-module__fDxavq__list",
  "nav": "Breadcrumb-module-scss-module__fDxavq__nav",
  "no-transform": "Breadcrumb-module-scss-module__fDxavq__no-transform",
  "rotate": "Breadcrumb-module-scss-module__fDxavq__rotate",
});
